import type { FC } from 'react';
import type { RadioCardOption } from '@components/RadioCardGroup';
import { RadioCardGroup } from '@components/RadioCardGroup';

type SyncSource = 'true' | 'false';

const options: RadioCardOption<SyncSource>[] = [
  {
    value: 'true',
    title: 'Sync Data from Contract Builder',
    description: 'Push the latest data from Contract Builder to PPL',
    dataTestId: 'sync-from-contract-builder',
  },
  {
    value: 'false',
    title: 'Sync Data from PPL',
    description: 'Pull the latest data from PPL into Contract Builder',
    dataTestId: 'sync-from-ppl',
  },
];

interface DataSourceSelectorProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const DataSourceSelector: FC<DataSourceSelectorProps> = ({ value, onChange }) => (
  <RadioCardGroup
    labelText="Select data type"
    options={options}
    value={String(value) as SyncSource}
    onChange={(next) => onChange(next === 'true')}
  />
);
